import {createApp} from 'vue'
import ConfirmChanges from './ConfirmChanges'

const el = '.kb-component--confirm-changes'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ConfirmChangesDOM)=>{
            const component = createApp(ConfirmChanges).use(Store)
            component.mount(ConfirmChangesDOM)
        })
    }
}